import Core from "@/modules/core/service/Core";

const url = {
    units        : "/api/user/units?all={0}",
    todos        : "/api/incident/issues/{0}?all={1}",
    assessments  : "/api/incident/issues/assessments/{0}?&all={1}&liftmanagement={2}",
    bouncetotal  : "/api/incident/bounced/totals",
    bouncemails  : "/api/incident/bounced",
    bounceconfirm: "/api/incident/bounced/{0}?confirmed={1}",
    totals       : "/api/incident/issues/totals?&all={0}&liftmanagement={1}",
    reset        : "/api/incident/todo"
}

export default {
    totals (customer, all, liftmanagement) {
        if (customer) {
            return Core.method.get(url.totals + "&customer=" + customer.id, all, liftmanagement);
        }

        return Core.method.get(url.totals, all, liftmanagement);
    },

    reset () {
        return Core.method.postVoid(url.reset, null);
    },

    units (customer, all) {
        const urls = customer ? (url.units + "&customer=" + customer.id ) : url.units;
        return Core.method.get(urls, all);
    },

    assessments (typeId, customer, all, liftmanagement) {
        const urls = customer ? (url.assessments + "&customer=" + customer.id ) : url.assessments;
        return Core.method.get(urls, typeId, all, liftmanagement);
    },

    list (typeId, all) {
        return Core.method.get(url.todos, typeId, all)
    },

    bounce: {
        totals () {
            return Core.method.get(url.bouncetotal);
        },

        mails () {
            return Core.method.get(url.bouncemails);
        },

        confirm (maildId, confirmed) {
            return Core.method.put (url.bounceconfirm, null, maildId, confirmed);
        }
    }
}